module.exports = __webpack_public_path__ + "static/media/text_icon_inside_rectangle.fe97b26c.svg";